module.exports = __webpack_public_path__ + "static/media/logo-splash.9e1891b2.png";